'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _IconButton = require('../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _NavigationMoreVert = require('../SvgIcon/NavigationMoreVert');

var _NavigationMoreVert2 = _interopRequireDefault(_NavigationMoreVert);

var _ = require('.');

var _2 = _interopRequireDefault(_);

var _typography = require('../styles/typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconMenu = (_temp2 = _class = function (_Component) {
  _inherits(IconMenu, _Component);

  function IconMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IconMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconMenu.__proto__ || Object.getPrototypeOf(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.open = function (open) {
      return _this.setState({ open: open });
    }, _this.handleIconButtonClick = function (e) {
      var _this$props$_this$sta = Object.assign({}, _this.props, _this.state),
          open = _this$props$_this$sta.open,
          _this$props$_this$sta2 = _this$props$_this$sta.onClick,
          onClick = _this$props$_this$sta2 === undefined ? function () {} : _this$props$_this$sta2;

      _this.open(!open);
      onClick(e);
    }, _this.handleMenuItemClick = function (e) {
      var value = e.target.getAttribute('value');
      var onChange = _this.props.onChange;
      var currentValue = _this.state.currentValue;


      if (value !== currentValue) {
        _this.setState({ value: value });
      }
      if (onChange) {
        onChange(value);
      }

      _this.handleRequestClose();
    }, _this.handleRequestClose = function () {
      return _this.open(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconMenu, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props$state = Object.assign({}, this.props, this.state),
            anchorOrigin = _props$state.anchorOrigin,
            iconClass = _props$state.iconClass,
            Icon = _props$state.iconComponent,
            open = _props$state.open,
            options = _props$state.options,
            transformOrigin = _props$state.transformOrigin,
            id = _props$state.id;

        var popoverProps = { anchorOrigin: anchorOrigin, transformOrigin: transformOrigin };

        var menuItems = options.map(function (option, i) {
          return _react2['default'].createElement(
            _.MenuItem,
            {
              property: 'pb:action',
              'typeof': 'ui:MenuItem',
              resource: '#' + option,
              key: i,
              value: option,
              onClick: _this2.handleMenuItemClick
            },
            option
          );
        });

        return _react2['default'].createElement(
          'div',
          {
            id: id,
            'typeof': 'ui:IconMenu',
            ref: function () {
              function ref(rootNode) {
                return _this2.rootNode = rootNode;
              }

              return ref;
            }()
          },
          _react2['default'].createElement(
            _IconButton2['default'],
            { className: iconClass, onClick: this.handleIconButtonClick },
            _react2['default'].createElement(Icon, null)
          ),
          _react2['default'].createElement(
            _2['default'],
            {
              anchorEl: this.rootNode,
              onRequestClose: this.handleRequestClose,
              open: open,
              popoverProps: popoverProps
            },
            menuItems
          )
        );
      }

      return render;
    }()
  }]);

  return IconMenu;
}(_react.Component), _class.propTypes = {
  /**
   * anchorOrigin: The location of the anchor on the `IconMenu` icon
   * vertical: ['top', 'center', 'bottom', x (px), fn(height) -> x (px)]
   * horizontal: ['left', 'center', 'right', x (px), fn(width) -> x (px)]
   */
  anchorOrigin: _PropTypes2['default'].origin,
  /**
   * The CSS class name of the icon button element.
   */
  iconClass: _PropTypes2['default'].string,
  /**
   * Component to be used as the icon button icon element.
   */
  iconComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Function called when menu option is selected.
   */
  onChange: _PropTypes2['default'].func,
  /**
   * Function called when iconComponent is clicked.
   * Can be used to stop propagation of the event if iconMenu is a child of a clickable node (i.e. a list item with `button` prop)
   */
  onClick: _PropTypes2['default'].func,
  /**
   * If `true`, then menu is displayed.
   */
  open: _PropTypes2['default'].bool,
  /**
   * Options to list in dropdown menu.
   */
  options: _PropTypes2['default'].array,
  /**
   * transformOrigin: The location of the anchor on the `Menu` popover
   * vertical: ['top', 'center', 'bottom', x (px), fn(height) -> x (px)]
   * horizontal: ['left', 'center', 'right', x (px), fn(width) -> x (px)]
   */
  transformOrigin: _PropTypes2['default'].origin
}, _class.defaultProps = {
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'bottom'
  },
  open: false,
  iconClass: null,
  iconComponent: _NavigationMoreVert2['default'],
  onChange: function () {
    function onChange() {}

    return onChange;
  }(),
  options: [],
  transformOrigin: {
    horizontal: function () {
      function horizontal(width) {
        return width - parseInt((0, _typography.rhythmByUnit)(2));
      }

      return horizontal;
    }(),
    vertical: 'top'
  }
}, _temp2);
exports['default'] = IconMenu;


IconMenu.displayName = 'IconMenu';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Menu/IconMenu.js
// module id = 721
// module chunks = 32